// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../cache-deps/virtual-store/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-error{border-width:1px;--tw-border-opacity:1;border-color:rgba(255,112,112,var(--tw-border-opacity))}", ""]);
// Exports
module.exports = exports;
